import CheckoutFooter from './checkout-footer.component';

export default CheckoutFooter;
